import { useApi } from './useApi';

interface RequestPasswordResetPayload {
  email: string;
}

interface ResetPasswordPayload {
  token: string;
  newPassword: string;
}

export const usePasswordRecovery = () => {
  const { request } = useApi();

  const requestPasswordReset = async (payload: RequestPasswordResetPayload) => {
    return request<{ message: string }>('api/auth/forgot-password', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  };

  const resetPassword = async (payload: ResetPasswordPayload) => {
    return request<{ message: string }>('api/auth/reset-password', {
      method: 'POST',
      body: JSON.stringify({ token: payload.token, password: payload.newPassword }),
    });
  };

  return { requestPasswordReset, resetPassword };
};
